import { cx } from './cx.ts';
import s from './DayHeader.module.css';
import t from './type.module.css';

/** C-05 date flag: `11.08` in an ink box; signal yellow when it's today (the view's signal block). */
export function DateFlag({ text, today = false }: { text: string; today?: boolean }) {
  return <span className={cx(s.flag, today && s.today, t.readoutM)}>{text}</span>;
}

/**
 * C-05 Day header: flag · weekday · day counter · destination · day total, over a 2pt day-colour
 * rule that matches the day's map route (the number is there too, so colour is never the only cue).
 */
export function DayHeader({
  flag,
  weekday,
  counter,
  destination,
  total,
  day,
  today = false,
  spoken,
}: {
  flag: string;
  weekday: string;
  counter: string;
  destination?: string;
  total?: string;
  /** Day index (1-based); the palette cycles through 8 hues. */
  day: number;
  today?: boolean;
  spoken: string;
}) {
  const hue = ((day - 1) % 8) + 1;
  return (
    <h3 className={s.header} aria-label={spoken}>
      <span className={s.row} aria-hidden="true">
        <DateFlag text={flag} today={today} />
        <span className={cx(t.label, s.muted)}>{weekday}</span>
        <span className={t.readoutS}>{counter}</span>
        {destination && <span className={cx(t.label, s.muted)}>{destination}</span>}
        {total && <span className={cx(t.readoutS, s.total)}>{total}</span>}
      </span>
      <span className={s.rule} style={{ background: `var(--color-day-${hue})` }} aria-hidden="true" />
    </h3>
  );
}
